import { SvgIcon, SvgIconProps } from '@mui/material';

const MapViewOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="MapViewOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M3 20C3 20.5523 3.44772 21 4 21H7V23H4C2.34315 23 1 21.6569 1 20V17H3V20Z" />
      <path d="M23 20C23 21.6569 21.6569 23 20 23H17V21H20C20.5523 21 21 20.5523 21 20V17H23V20Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5ZM11.0879 13.6953L11.3398 14.0059L11.2432 14.3936C11.1912 14.6015 11.2527 14.7416 11.3682 14.874C11.4305 14.9455 11.5017 15.0036 11.5596 15.0439C11.5871 15.0632 11.6087 15.0768 11.6211 15.084L11.624 15.0859L12.0625 15.3057L12.0654 16.998C12.8309 16.9882 13.5545 16.8072 14.2002 16.4902V15.5332H12.6758V13.4004H10.8477L11.0879 13.6953ZM7.05273 11.2744C7.01829 11.5113 7 11.7535 7 12C7 14.2257 8.45464 16.1108 10.4648 16.7588L10.4639 16.2178C10.3681 16.1384 10.2634 16.0419 10.1621 15.9258C9.8731 15.5943 9.59291 15.0854 9.62598 14.4336L8.54785 13.1074L7.45508 11.7734L7.45117 11.7686L7.05273 11.2744ZM13.9336 9.13379H12.0703V10.4668H10.4668V11.7998H14.2764V13.9336H15.0645L15.7998 14.6689V15.248C16.5475 14.3742 17 13.2402 17 12C17 9.92395 15.7351 8.14268 13.9336 7.38672V9.13379ZM12 7C10.1518 7 8.53824 8.003 7.67285 9.49414L8.69727 10.7646L8.86621 10.9717V8.86621H10.4697V7.5332H12.333V7.01172C12.2229 7.00448 12.1119 7 12 7Z"
      />
      <path d="M7 3H4C3.44772 3 3 3.44772 3 4V7H1V4C1 2.34315 2.34315 1 4 1H7V3Z" />
      <path d="M20 1C21.6569 1 23 2.34315 23 4V7H21V4C21 3.44772 20.5523 3 20 3H17V1H20Z" />
    </SvgIcon>
  );
};

export default MapViewOutlined;
